import { observable, action, makeObservable } from 'mobx';

import { EhrFieldsVersionParams, EntryFieldData } from 'chaika-frontend-types/frontend-cms';

import { EntryFields, IField } from '@store/models/EntryFields';
import { assertIsDefined } from '@utils/assertIsDefined';

const FIELD_HISTORY_SNAPSHOT_MESSAGE = 'Field history version is an entry snapshot with id, creation time and author';

export class FieldHistory {
    @observable
    public id: string;

    @observable
    public authorId: string;

    @observable
    public author: string;

    @observable
    public creationTime: string;

    @observable
    private fields_: EntryFields = new EntryFields();

    public constructor({ entryId, creationTime, authorId, author, fields }: EhrFieldsVersionParams) {
        makeObservable(this);

        assertIsDefined(entryId, FIELD_HISTORY_SNAPSHOT_MESSAGE);
        assertIsDefined(creationTime, FIELD_HISTORY_SNAPSHOT_MESSAGE);
        assertIsDefined(authorId, FIELD_HISTORY_SNAPSHOT_MESSAGE);
        this.id = entryId;
        this.creationTime = creationTime;
        this.authorId = authorId;
        this.author = author;

        const fieldData = this.makeFieldParamsFromObject(fields ?? {});

        this.fields_ = new EntryFields(fieldData);
    }

    @action
    public reset() {
        this.id = '';
        this.creationTime = '';
        this.authorId = '';
        this.author = '';

        this.fields_.reset();
    }

    public getField(name: string): IField {
        return this.fields_.get(name);
    }

    public getFieldValue<T>(name: string): T {
        return this.fields_.getValue(name);
    }

    public getFieldNames(): string[] {
        return this.fields_.fieldNames;
    }

    private makeFieldParamsFromObject(ehrFieldData: object): EntryFieldData[] {
        const fieldNames = Object.keys(ehrFieldData);

        return fieldNames.map(name => ({
            name,
            value: ehrFieldData[name as keyof typeof ehrFieldData],
        }));
    }
}
